import { ColumnsType } from 'antd/lib/table';
import {
  getReportExportTableData,
  ReportExportMetric,
  toReportExportCellValue,
} from './report-export-table-data';

interface ExportReportToExcelParams<T> {
  columns: ColumnsType<T>;
  fileName: string;
  metrics: ReportExportMetric[];
  reportTitle: string;
  rows: T[];
}

export const exportReportToExcel = async <T>({
  columns,
  fileName,
  metrics,
  reportTitle,
  rows,
}: ExportReportToExcelParams<T>): Promise<void> => {
  const XLSX = await import('xlsx');
  const { header, rows: tableRows } = getReportExportTableData<T>(
    columns,
    rows,
  );
  const sheetData = [
    [reportTitle],
    [],
    ...metrics.map(({ caption, label, value }: ReportExportMetric) => [
      label,
      toReportExportCellValue(value),
      caption ?? '',
    ]),
    [],
    header,
    ...tableRows,
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet(sheetData),
    reportTitle.slice(0, 31),
  );

  XLSX.writeFile(workbook, fileName);
};
